module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "\u503C\u5FC5\u987B\u662F ".concat(args.maxValue, " \u6216\u66F4\u65E9\u65E5\u671F\u3002");
  },
  "rangeReversed": "\u5F00\u59CB\u65E5\u671F\u5FC5\u987B\u65E9\u4E8E\u7ED3\u675F\u65E5\u671F\u3002",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "\u503C\u5FC5\u987B\u662F ".concat(args.minValue, " \u6216\u66F4\u665A\u65E5\u671F\u3002");
  },
  "unavailableDate": "\u6240\u9009\u65E5\u671F\u4E0D\u53EF\u7528\u3002"
};